import {MERGED} from "../../../Constants/StatusConstants";
import {useAlert} from "../../alerts/AlertContext";
import {Link} from "react-router-dom";
import * as React from "react";
import PropTypes from "prop-types";


function TicketIdLinkView(props){
    const showAlert = useAlert();

    const id = props.id;
    const mergeStatus = props.mergeStatus;

    const onClickTicketHandler = (e) => {
        if (mergeStatus !== "" && mergeStatus !== MERGED) {
            showAlert("This ticket merged to " + props.mergedTicketId, "info");
            e.preventDefault(); // Stop navigation if validation fails
        }
    }

    return (
        <Link
            to={`/editTicket/${id}`}
            onClick={onClickTicketHandler}
        >
            {id}
        </Link>
    )
}
TicketIdLinkView.propTypes = {
    id: PropTypes.string.isRequired,
    mergeStatus: PropTypes.string.isRequired,
}

export default TicketIdLinkView;